module.exports = __webpack_public_path__ + "assets/img/riskControl_a.fb0a99a9.jpg";